export { default } from './SpecialOffer';
